import { DiscordWhite, RedditWhite, TelegramWhite, TwitterWhite, } from 'src/assets/components'
import './PageFooter.css'
import { EcosystemLinks, ResourceLinks, SocialMediaLinks, } from 'src/constants/ResourceLinks'

const PageFooter: React.FC = () => {
  return (
    <div className="footer-background">
      <div className="container footer-container">
        <div className="link-container">
          <div className="info-container">
            <h1 className="footer-title">Ecosystem</h1>
            <ul>
              <li>
                <a className="footer-link" href={EcosystemLinks.Demex} target="_blank"
                   rel="noopener noreferrer"
                >
                  Demex
                </a>
              </li>
              <li>
                <a
                  className="footer-link"
                  href={EcosystemLinks.DemexScan}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CarbonScan
                </a>
              </li>
            </ul>
          </div>
          <div className="info-container">
            <h3 className="footer-title">Resources</h3>
            <ul>
              <li>
                <a
                  className="footer-link"
                  href={ResourceLinks.Docs}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Developer Docs
                </a>
              </li>
              <li>
                <a
                  className="footer-link"
                  href={ResourceLinks.GitHub}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="social-media-container">
          <h3 className="footer-title">Follow Us</h3>
          <div className="social-media-links">
            <a
              href={SocialMediaLinks.Telegram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TelegramWhite className="social-media-icons" />
            </a>
            <a
              href={SocialMediaLinks.Twitter}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterWhite className="social-media-icons" />
            </a>
            <a
              href={SocialMediaLinks.Discord}
              target="_blank"
              rel="noopener noreferrer"
            >
              <DiscordWhite className="social-media-icons" />
            </a>
            <a
              href={SocialMediaLinks.Reddit}
              target="_blank"
              rel="noopener noreferrer"
            >
              <RedditWhite className="social-media-icons" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageFooter
